import React,{Component} from "react";





export default class ViewHomeWork extends Component{
	constructor(props) {
    super(props);

    this.state = {
      startDate: undefined,
      endDate: undefined,
      height: '100%'
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
  }

  handleStartDateChange(value) {
    this.setState({
      ...this.state,
      ...{ startDate: new Date(value) }
    });
  }

  componentDidMount(){  
    this.setState({height:(this.props.data.length<3?'350%':'100%')});
  }
  
	render(){
		return(
		<div>
		
    {/*
		<Card>
        <CardHeader className="border-bottom">
          <h6 className="m-0">View HomeWork</h6>
        </CardHeader>
        
        <CardBody className="pt-0">
    */}
        
          <table className="table mb-0" style={{height: '500%'}}>
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    #
                  </th>
                  <th scope="col" className="border-0">
                    Subject
                  </th>
                  <th scope="col" className="border-0">
                    Title
                  </th>
                  <th scope="col" className="border-0">
                    Description
                  </th>
                  
                  <th scope="col" className="border-0">
                    	Delete
                  </th>
                  
                </tr>
              </thead>
             <tbody>
                  {
                      this.props.data.map((item,i)=>{
                                        return <TRow key={i} data={item} index={i+1}
                                                    deletehomework={this.props.deletehw}
                                                />
                         })
                    }
                
              </tbody>
            </table>

        {/*
        </CardBody>
      </Card>
    */}

      </div>

		)
	}
}



class TRow extends Component{
  render(){
    return(

         <tr>
                  <td>{this.props.data.id}</td>
                  <td>{this.props.data.subject}</td>
                  <td>{this.props.data.title}</td>
                  <td>{this.props.data.description}</td>
                  <td style={{color:'red',fontSize: 30}} onClick={()=>{this.props.deletehomework(this.props.data.class_name,this.props.data.id)}}><i class="material-icons">delete</i></td>
                </tr>

    )
  }
}


